module.exports = __webpack_public_path__ + "img/moon.65b727fa.svg";